export class Tracker {
    public _id: string;
    public side: string;
    public state: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/tracker.ts